import { RootState } from "../root.reducer";

export const additionalProductsSelector = (state: RootState) =>
  state.additionalProducts;
